import React from "react";
//#region redux
//#endregion
//#region types
import { MessageBubbleDetails } from "models/propTypes/messagePropTypes";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { useFormFieldMessageProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useFormFieldMessage(
  props: useFormFieldMessageProps,
  hideErrorBubble?: boolean
): MessageBubbleDetails | undefined {
  const { errors, value, touched, customMessageHandler, helperText, values } = props;
  const [message, setMessage] = React.useState<MessageBubbleDetails>();

  const setUpdatedMessage = (newMessage?: MessageBubbleDetails) =>
    setMessage((oldMessage) => {
      if (oldMessage?.message !== newMessage?.message || oldMessage?.type !== newMessage?.type) {
        return newMessage;
      }
      return oldMessage;
    });

  React.useEffect(() => {
    // A custom handler may ask the server; an answer for values that have since changed must not win.
    let current = true;
    if (hideErrorBubble) setUpdatedMessage(undefined);
    else if (!!errors && !!touched)
      setUpdatedMessage(
        typeof errors === "string"
          ? {
              message: LocalizationHelperInstance.getFormattedMessage(errors as string, errors as string),
              type: StyleEnums.DisplayType.Danger,
            }
          : undefined
      );
    else if (customMessageHandler)
      customMessageHandler(values, touched).then((message) => {
        if (current) setUpdatedMessage(message);
      });
    else if (helperText && (value === null || value === undefined || value === ""))
      setUpdatedMessage({
        message: LocalizationHelperInstance.getFormattedMessage(helperText as string, helperText as string),
        type: StyleEnums.DisplayType.Info,
      });
    else if (!!errors && !touched) {
      setUpdatedMessage(
        typeof errors !== "string" || errors === TranslationKeys.Validations.Required
          ? undefined
          : {
              message: LocalizationHelperInstance.getFormattedMessage(errors as string, errors as string),
              type: StyleEnums.DisplayType.Info,
            }
      );
    } else setUpdatedMessage(undefined);
    return () => {
      current = false;
    };
  }, [errors, values, touched, helperText, customMessageHandler]);

  return message;
}

export default useFormFieldMessage;
